<template>
  <div>
    <v-menu
      v-for="file in files"
      :key="file.id"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          outlined
          tile
          v-bind="attrs"
          :loading="file.active"
          :color="file.error ? 'red' : 'black'"
          class="mr-1 mb-1 pa-1 py-3"
          v-on="on"
        >
          <v-icon color="blue darken-3">
            {{ mdiFileDocumentOutline }}
          </v-icon>
          {{ file.name }}
          <v-icon>
            {{ mdiMenuDown }}
          </v-icon>
        </v-btn>
      </template>
      <v-list
        dense
      >
        <v-list-item @click.prevent="$refs.upload.remove(file)">
          <v-list-item-title>
            <v-icon
              small
              class="mr-1"
              color="red"
            >
              {{ mdiClose }}
            </v-icon>
            {{ $t('eDocInternal.deleteAttachment') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click.prevent="downloadFile(file)">
          <v-list-item-title>
            <v-icon
              small
              class="mr-1"
              color="dark"
            >
              {{ mdiDownload }}
            </v-icon>
            {{ $t('PdfViewer.Download') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <br v-if="files && files.length">

    <v-btn
      depressed
      @click="onAddFile"
    >
      <v-icon v-if="useAttachmentIcon">
        {{ mdiPaperclip }}
      </v-icon>
      {{ label }}
    </v-btn>

    <file-upload
      v-show="false"
      ref="upload"
      v-model="files"
      :input-id="inputId"
      :post-action="postUrl"
      :extensions="extensions"
      :accept="accept"
      :multiple="multiple"
      :size="size || 0"
      :drop="drop"
      :headers="{'Authorization': `Bearer ${this.$g2eOauth.token}`}"
      :maximum="maximum || 0"
      @input-filter="inputFilter"
      @input-file="inputFile"
      @input="inputUpdate"
    />
  </div>
</template>

<script>

import SFileUploaderWithEntity from './SFileUploaderWithEntity'
import { mdiMinusCircleOutline, mdiCheckCircle, mdiFileDocumentOutline, mdiClose, mdiMenuDown, mdiPaperclip, mdiDownload } from '@mdi/js'
import docFlowApi from '@/api/eDocInternal/docFlow'

export default {
  extends: SFileUploaderWithEntity,
  props: {
    useAttachmentIcon: {
      type: Boolean,
      required: false
    }
  },
  data: function () {
    return {
      mdiMinusCircleOutline: mdiMinusCircleOutline,
      mdiCheckCircle: mdiCheckCircle,
      mdiFileDocumentOutline: mdiFileDocumentOutline,
      mdiClose: mdiClose,
      mdiMenuDown: mdiMenuDown,
      mdiPaperclip: mdiPaperclip,
      mdiDownload: mdiDownload
    }
  },
  methods: {
    downloadFile (file) {
      docFlowApi.downloadDocumentByDocCode(file.response,
        resp => {
          if (resp.status === 201 || resp.status === 200) {
            const url = window.URL.createObjectURL(new Blob([resp.data]))
            const link = document.createElement('a')
            link.href = url
            // let disposition = resp.headers['content-disposition']
            // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
            link.setAttribute('download', file.name)
            link.click()
            window.URL.revokeObjectURL(url)
          }
        }
      )
    }
  }
}
</script>
